import {
    AREAS_FETCHED,
    FETCHED_STATIONS,
    SELECTED_AREA,
    SELECTED_NAV_STATION,
    SELECTED_ZONE,
    ZONES_FETCHED
} from '../../actions/types';

let defaultState = {
    areas: [],
    zones: [],
    stations: [],
    selectedArea: -1,
    selectedZone: -1,
    selectedStation: -1
};

export default function(state = defaultState, action){
    switch (action.type){
        case AREAS_FETCHED:
            return {...state, areas:action.payload};
        case ZONES_FETCHED:
            return {...state, zones: action.payload};
        case FETCHED_STATIONS:
            return {...state, stations:action.payload};
        case SELECTED_AREA:
            return {...state, selectedArea:action.payload};
        case SELECTED_ZONE:
            return {...state, selectedZone:action.payload};
        case SELECTED_NAV_STATION:
            return {...state, selectedStation:action.payload};
        default:
            break;
    }
    return state;
}


// WEBPACK FOOTER //
// ./src/reducers/Navigation/index.js